<template>
  <main-template>
    <v-row>
      <v-col>
        <v-btn text small color="primary" class="pl-0" @click="voltar">
          <v-icon left small>mdi-chevron-left</v-icon>
          Voltar
        </v-btn>
        <h1>Detalhes do Aluno</h1>
      </v-col>
    </v-row>

    <v-row v-if="caso">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="d-flex align-center flex-wrap" style="gap: 12px">
              <div>
                <div class="text-h6 font-weight-bold">{{ caso.aluno }}</div>
                <div class="text-caption grey--text">
                  Matrícula {{ caso.matricula }} — {{ caso.turma }} — {{ caso.escola }}
                </div>
              </div>

              <v-divider inset vertical />

              <e-chip-risco-evasao
                :categoria="caso.categoria"
                :categoria-rotulo="caso.categoria_rotulo"
                :status="caso.status"
              />
            </div>
          </v-card-title>

          <v-tabs v-model="aba" show-arrows>
            <v-tab>Dados Gerais</v-tab>
            <v-tab>Histórico de Frequência</v-tab>
            <v-tab>Acompanhamentos</v-tab>
          </v-tabs>

          <v-divider />

          <v-card-text>
            <v-tabs-items v-model="aba">
              <v-tab-item>
                <e-dados-gerais-tab :caso="caso" />
              </v-tab-item>

              <v-tab-item>
                <e-historico-frequencia-tab v-if="aba === 1" :caso-id="caso.id" />
              </v-tab-item>

              <v-tab-item>
                <e-acompanhamentos-tab
                  v-if="aba === 2"
                  :caso="caso"
                  @caso-atualizado="(atualizado) => (caso = atualizado)"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import EAcompanhamentosTab from "@/components/BuscaAtiva/EAcompanhamentosTab.vue";
import EChipRiscoEvasao from "@/components/BuscaAtiva/EChipRiscoEvasao.vue";
import EDadosGeraisTab from "@/components/BuscaAtiva/EDadosGeraisTab.vue";
import EHistoricoFrequenciaTab from "@/components/BuscaAtiva/EHistoricoFrequenciaTab.vue";

export default {
  components: { EAcompanhamentosTab, EChipRiscoEvasao, EDadosGeraisTab, EHistoricoFrequenciaTab },
  data() {
    return {
      caso: null,
      aba: 0,
    };
  },
  async mounted() {
    this.$loaderService.open("Carregando os detalhes do aluno");
    try {
      this.caso = await this.$services.buscaAtivaService.caso(this.$route.params.caso_id);
    } catch (error) {
      this.$handleError(error);
    } finally {
      this.$loaderService.close();
    }
  },
  methods: {
    voltar() {
      if (window.history.length > 1) {
        return this.$router.back();
      }
      return this.$router.push({ name: "buscaAtiva.visaoGeral" });
    },
  },
};
</script>
